<template>
  <div id="app" class="page full-height">
    <el-container class="full-height"
    v-if="isAuthenticated">
      <el-header class="bg-primary">
        <top-nav />
      </el-header>
      <el-container class="narrow">
        <el-aside width="240px">
          <side-nav />
        </el-aside>
        <el-main class="vertical-shadow">
          <router-view />
        </el-main>
      </el-container>
      <el-footer class="bg-light-gray">
        <footer-content />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TopNav from '@/components/global/TopNav'
import SideNav from '@/components/global/SideNav'
import FooterContent from '@/components/global/FooterContent'

export default {
  computed: {
    ...mapGetters([
      'isAuthenticated'
    ])
  },
  components: {
    TopNav,
    SideNav,
    FooterContent
  }
}
</script>
